module.exports = __webpack_public_path__ + "static/media/hotelInfo.1c3ba5ad.svg";